export const FETCH_ACCOUNT_USER_OWNED_PROPERTIES_REQUEST = 'FETCH_ACCOUNT_USER_OWNED_PROPERTIES_REQUEST'
export const FETCH_ACCOUNT_USER_OWNED_PROPERTIES_SUCCESS = 'FETCH_ACCOUNT_USER_OWNED_PROPERTIES_SUCCESS'
export const FETCH_ACCOUNT_USER_OWNED_PROPERTIES_FAILURE = 'FETCH_ACCOUNT_USER_OWNED_PROPERTIES_FAILURE'